
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import parse from "html-react-parser";
import type { GetStaticProps, NextPage } from "next/types";
import { PAGE } from "../consts/ppages";
import { getPageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        content: string;
        videos: {
            videos: {
                title: string;
                url: string;
            }[];
        };
        en: {
            title: string;
            content: string;
            videos: {
                videos: {
                    title: string;
                    url: string;
                }[];
            };
        };
    };
}
const PromotionalVideos: NextPage<IPage> = ({ page }) => {
    const VIDEOS = page?.videos?.videos
        ? page?.videos?.videos
        : page?.en.videos.videos;
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/videos", hrefLang: "x-default" },
            { href: "https://knswindows.com/videos/videos", hrefLang: "en" },
            { href: "https://knsokna.pl/videos", hrefLang: "pl" },
            { href: "https://knsfenster.de/videos", hrefLang: "de" },
            { href: "https://kns-okna.eu/videos", hrefLang: "cs" },
            { href: "https://knsfinestre.it/videos", hrefLang: "it" },
            { href: "https://knsfenetres.fr/videos", hrefLang: "fr" },
            { href: "https://knsokna.eu/videos", hrefLang: "hu" },
        ]}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <div>{parse(page?.content || "")}</div>
          {VIDEOS.map((video) => {
            const url = new URL(video.url || "");
            const videoUrl = url.pathname.slice(1);
            return (<div className="mb-4 text-center" key={video.url}>
                <h3 className="my-4 font-bold">{video?.title}</h3>
                <div className="relative mx-auto h-0 max-w-7xl overflow-hidden" style={{ paddingBottom: "56.25%" }}>
                  <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute top-0 left-0 h-full w-full" height="315" src={`https://www.youtube.com/embed/${videoUrl}`} title={video?.title} width="100%"/>
                </div>
              </div>);
        })}
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.VIDEOS[LOCALE as keyof typeof PAGE.VIDEOS] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default PromotionalVideos;

    async function __Next_Translate__getStaticProps__1a19cd2c0e3__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/videos',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2c0e3__ as getStaticProps }
  